// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zNyh6","colBig":"styles_colBig__FBBt2","colSmall":"styles_colSmall__1JrF-"};